module.exports = __webpack_public_path__ + "static/media/3.d42dbe0c.jpg";